export default __webpack_public_path__ + "255685ac3485ac8185bb26c0a585ac28.png";